// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__2VBk3","title":"style_title__2drHW","rows":"style_rows__189N2"};